import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import AccountSuscriptionsList from './StandingOrdersList/StandingOrdersList'
import AccountSuscriptionsDetails from './StandingOrdersDetails/StandingOrdersDetails'

const AccountStandingOrders = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <AccountSuscriptionsList />
      </Route>
      <Route exact path={`${path}/:orderNo`}>
        <AccountSuscriptionsDetails />
      </Route>
    </Switch>
  )
}

export default AccountStandingOrders
